export const DOUBLE_CLICK_TIME = 500;

// Speed used by the off-canvas auto-scroll RAF when the cursor has wandered
// fully off the canvas (over the toolbar/sheet bar/sidebar or off the
// browser window). Tuned for "cover distance fast" since the user has
// clearly committed to scrolling. The scroll formula is quadratic in
// `speed` (`speed * speed * 60/1000`), so 13 yields ~70% more per-frame
// scroll distance than the in-canvas speed below.
export const MOUSE_EDGES_SPEED = 13;

// Speed used by the in-canvas `MouseEdges` plugin while the cursor is still
// inside the canvas's edge zone. Slower than the off-canvas speed for finer
// control at the boundary.
export const IN_CANVAS_MOUSE_EDGES_SPEED = 10;

export const MOUSE_EDGES_DISTANCE = 20;
